module.exports = __webpack_public_path__ + "static/media/pickup_landing_page.1a882e6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pickup_landing_page.png
// module id = 40
// module chunks = 0